import { Injectable } from '@angular/core';
import { BaseContentService } from './base-content-service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { UpdateEmailContent } from './def/update-email-content';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root'
})
export class UpdateEmailContentService extends BaseContentService<
UpdateEmailContent
> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, UpdateEmailContentService.updateEmailData);
  }

  get data$(): Observable<UpdateEmailContent> {
    if (!this.loaded) {
      return this.getUpdateEmailData();
    }

    return of(this.data);
  }

  getUpdateEmailData(): Observable<UpdateEmailContent> {
    const url = `${this.serviceBaseUrl}updateemail`;
    return this.get<UpdateEmailContent>(url).pipe(
      map(data => {
        this.data = this.updateEmailMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private updateEmailMapper(
    data: UpdateEmailContent
  ): UpdateEmailContent {
    if (!data) return;

    return data;
  }
  // getStateData(): Observable<any> {
  //   const url =
  //     'https://dev.artisanedge.com/api/sitecore/ArtisanEdgeDataServices/GetStates';
  //   return this.get(url);
  // }

  private static updateEmailData: UpdateEmailContent = {
    pageName: 'updateemail',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '0',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: 'city',
              label: '',
              fieldType: '',
              fieldID: 'city',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: []
      }
    ],   
    buttons: [
      {
        keyText: ''
      }
    ]    
  };
}
